@let isLink = !!url();
@let isAnisTheme = theme() === "ANIS" && !buttonDisabled();
@let isWhiteTheme = theme() === "WHITE" && !buttonDisabled();
@let isDisabledTheme = buttonDisabled();
@if (isLink) {
  @let isExternalLink = url()!.startsWith("http");
  @if (isExternalLink) {
    <a
      (click)="onButtonClick.emit()"
      [href]="url()"
      rel="noopener noreferrer"
      target="_blank"
      [ngClass]="{ 'block w-full': isFullWidth() }">
      <ng-container *ngTemplateOutlet="buttonContent" />
    </a>
  } @else {
    <a
      (click)="onButtonClick.emit()"
      [queryParams]="queryParams()"
      [routerLink]="url()"
      [ngClass]="{ 'block w-full': isFullWidth() }">
      <ng-container *ngTemplateOutlet="buttonContent" />
    </a>
  }
} @else {
  <button (click)="onButtonClick.emit()" [disabled]="buttonDisabled()" [ngClass]="{ 'block w-full': isFullWidth() }">
    <ng-container *ngTemplateOutlet="buttonContent" />
  </button>
}
<ng-template #buttonContent>
  <div
    [ngClass]="{
      'bg-anis': isAnisTheme,
      'bg-white': isWhiteTheme,
      'bg-gray': isDisabledTheme,
      'block w-full': isFullWidth(),
      'inline-block': !isFullWidth(),
      'btn-ripple active:translate-x-0.5 active:translate-y-0.5 active:drop-shadow-none': !buttonDisabled(),
      'cursor-not-allowed': buttonDisabled(),
    }"
    class="drop-shadow-custom min-h-12 content-center items-center gap-x-2 rounded-xl px-5 text-[14px]">
    @let hasLeftIcon = !!leftIconSrc();
    <span
      [class.grid-cols-[21px_auto_17px]]="hasLeftIcon"
      [class.grid-cols-[auto_17px]]="!hasLeftIcon"
      [ngClass]="{ 'justify-center': isFullWidth() }"
      class="grid items-center gap-x-2.5">
      @if (leftIconSrc(); as src) {
        <app-svg [width]="21" class="w-[21px]" [src]="src" [inline]="true" />
      }
      <span>{{ label() }}</span>
      @if (isLoading()) {
        <svg
          class="size-[18px] origin-center overflow-visible"
          preserveAspectRatio="xMidYMid meet"
          viewBox="0 0 37 37"
          xmlns="http://www.w3.org/2000/svg">
          <path
            class="stroke-black/10 transition-colors duration-500"
            d="M0.37 18.5 C0.37 5.772 5.772 0.37 18.5 0.37 S36.63 5.772 36.63 18.5 S31.228 36.63 18.5 36.63 S0.37 31.228 0.37 18.5"
            fill="none"
            pathLength="100"
            stroke-width="5" />
          <path
            class="animate-travel stroke-black transition-colors duration-500"
            d="M0.37 18.5 C0.37 5.772 5.772 0.37 18.5 0.37 S36.63 5.772 36.63 18.5 S31.228 36.63 18.5 36.63 S0.37 31.228 0.37 18.5"
            fill="none"
            pathLength="100"
            stroke-width="5"
            style="stroke-dasharray: 15, 85; stroke-linecap: round" />
        </svg>
      } @else {
        <app-svg [height]="11" [width]="17" class="w-[17px]" src="assets/icons/arrow-right.svg" />
      }
    </span>
  </div>
</ng-template>
